/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { EditButton, List, TextField } from 'react-admin'
import { makeStyles } from '@material-ui/core'
import ListTitle from '../../components/ListTitle'
import Datagrid from '../../components/Datagrid/Datagrid'
import Filter from '../../components/Filter/FilterComponents'

const styles = {
    myHeader: {
        '&&:before': {
            content: '" ⇅ "',
        },
    },
}
const useStyles = makeStyles(styles)

export default function DepartmentList(props) {
    const classes = useStyles(props)
    return (
        <List
            sort={{ field: 'code', order: 'ASC' }}
            filters={<Filter {...props} />}
            {...props}
        >
            <>
                <ListTitle label="Department" />
                <Datagrid rowClick="edit">
                    <TextField
                        label="Code"
                        headerClassName={classes.myHeader}
                        source="code"
                    />
                    <TextField
                        label="Description"
                        headerClassName={classes.myHeader}
                        source="description"
                    />
                    <EditButton basePath="/PY_DepartmentTAB" />
                </Datagrid>
            </>
        </List>
    )
}
